// extracted by mini-css-extract-plugin
export default {"alert":"nELfQe7","success":"RrT8Ngh","error":"oi63Rmm"};